import React, { Component } from 'react';
import { connect } from 'react-redux';
import Title from '../../../../Title';
import Icon from '../../../../Icon';
import { geti18n } from '../../../../../reducers/i18n';
import { getTemporalPdfUrl, temporalPdfFetched } from '../../../../../reducers/contracts'
import { openContractIframe, closeContractIframe } from '../../../../../contractsService';

class HelloSignIframeContainer extends Component {
  componentDidMount(){
    const { contractUrl, sign } = this.props;
    openContractIframe(contractUrl, sign);
  }

  componentWillUnmount(){
    closeContractIframe();
  }

  pdfDownloadLink(){
    const i18n = this.props.i18n;
    return this.props.temporalPdfFetched ? (
      <div className="contracts__iframe__download">
        <p className="contracts__iframe__download__text">{i18n(`onboarding.contractIframe.download`)}</p>
        <a href={this.props.temporalPdfUrl} target="_blank">
          <Icon name="download" className="contracts__iframe__download__icon" />
        </a>
      </div>
    ): null
  }

  render(){
    const pdfDownloadLink = this.pdfDownloadLink();
    const { contractType, close, i18n } = this.props;
    return(
      <div className='text-center contracts__iframe'>
          
            <div>
              <Title text={i18n(`onboarding.contractIframe.${contractType}.title`)} className="form__title" />
              <Icon name="cross" className="contracts__iframe__close" onClick={close} />
              { pdfDownloadLink }
            </div>
          
          <div id="myHSContainer" className="contracts__viewer"> </div>
        </div>
    );
  }

}

const mapStateToProps = state => ({
  i18n: geti18n(state),
  temporalPdfUrl: getTemporalPdfUrl(state),
  temporalPdfFetched: temporalPdfFetched(state)

});

export default connect(mapStateToProps)(HelloSignIframeContainer)


// WEBPACK FOOTER //
// ./src/components/Views/Onboarding/Steps/Contracts/HelloSignIframeContainer.js